import React, { useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Statistics from './components/Statistics';
import Services from './components/Services';
import InvestmentSummary from './components/InvestmentSummary';
import PropertyInvestment from './components/PropertyInvestment';
import Video from './components/Video';
import Companies from './components/Companies';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Chatbot from './components/Chatbot';

const App = () => {
  useEffect(() => {
    // Initialize sections for navigation
    const initializeNavigation = () => {
      const sections = [
        { id: 'hero', selector: '#hero' },
        { id: 'services', selector: '#services' },
        { id: 'testimonials', selector: '#testimonials' },
        { id: 'contact', selector: '#contact' }
      ];

      // Ensure sections have proper IDs
      sections.forEach(section => {
        const element = document.querySelector(section.selector);
        if (element && !element.id) {
          element.id = section.id;
        }
      });
    };

    // Set scroll behavior to auto initially for better performance
    document.documentElement.style.scrollBehavior = 'auto';
    
    // Initialize navigation after a short delay to ensure DOM is ready
    setTimeout(() => {
      initializeNavigation();
      // Reset to smooth scrolling after initialization
      document.documentElement.style.scrollBehavior = 'smooth';
    }, 100);

    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&display=swap');
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          html {
            /* Start with auto to prevent initial scroll issues */
            scroll-behavior: auto;
            /* Reduced base font size to make everything globally smaller */
            font-size: 93.75%; 
          }

          body {
            font-family: 'Comfortaa', 'Cormorant Garamond', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
            background: #000;
            color: #fff;
            overflow-x: hidden;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-weight: 400; 
            line-height: 1.5; /* Tightened line height slightly */
            /* Enable smooth scrolling after initial load */
            scroll-behavior: smooth;
          }

          .App {
            text-align: center;
            position: relative;
            display: flex;
            flex-direction: column;
          }

          /* TARGETING THE GAPS: Maintaining tight spacing */
          section {
            padding: 12px 20px !important; 
            min-height: 0 !important;      
            height: auto !important;       
            margin: 0 !important;
          }

          /* Force specific removal of gap for the video and investment sections */
          #investment-summary, #video, .video-section, .investment-section {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
            margin-top: -1px !important; 
          }

          /* Ensure sections have proper IDs for navigation */
          #hero, #services, #testimonials, #contact {
            scroll-margin-top: 80px; /* Adjust based on your navigation height */
          }

          h2 {
            font-family: 'Cormorant Garamond', serif;
            /* Reduced title size from 3.2rem */
            font-size: 2.2rem; 
            margin-bottom: 1rem;
            font-weight: 500;
            letter-spacing: -0.01em;
          }

          .navigation {
            z-index: 1000;
          }
          
          .comfortaa {
            font-family: 'Comfortaa', cursive;
          }
          
          .cormorant {
            font-family: 'Cormorant Garamond', serif;
          }

          /* Smooth scrolling for anchor links */
          html:not(.no-smooth-scroll) {
            scroll-behavior: smooth;
          }

          /* Prevent flash of unstyled content */
          .App > * {
            opacity: 0;
            animation: fadeIn 0.5s ease-in forwards;
          }

          @keyframes fadeIn {
            to {
              opacity: 1;
            }
          }

          .App > *:nth-child(1) { animation-delay: 0.1s; }
          .App > *:nth-child(2) { animation-delay: 0.2s; }
          .App > *:nth-child(3) { animation-delay: 0.3s; }
          .App > *:nth-child(4) { animation-delay: 0.4s; }
          .App > *:nth-child(5) { animation-delay: 0.5s; }
          .App > *:nth-child(6) { animation-delay: 0.6s; }
          .App > *:nth-child(7) { animation-delay: 0.7s; }
          .App > *:nth-child(8) { animation-delay: 0.8s; }
          .App > *:nth-child(9) { animation-delay: 0.9s; }
          .App > *:nth-child(10) { animation-delay: 1s; }
          .App > *:nth-child(11) { animation-delay: 1.1s; }
        `}
      </style>
      <div className="App">
        <Navigation />
        <div id="hero">
          <Hero />
        </div>
        <Statistics />
        <PropertyInvestment />
        <div id="services">
          <Services />
        </div>
        <InvestmentSummary />
        <Video />
        <Companies />
        <div id="testimonials">
          <Testimonials />
        </div>
        <div id="contact">
          <Contact />
        </div>
        <Chatbot />
      </div>
    </>
  );
};

export default App;